import './AgWidget.scss';
import { ReactNode } from 'react';
import classNames from 'classnames';
import { IconType } from 'react-icons';

interface AgWidgetProps {
    children: ReactNode;
    title: ReactNode;
    className?: string;
    gridRows: number;
    gridColumns: number;
    disablePadding?: boolean;
    Icon?: IconType;
}

export function AgWidget({
    title,
    children,
    className,
    gridRows,
    gridColumns,
    disablePadding = false,
    Icon,
}: AgWidgetProps) {
    return (
        <div
            className={classNames('AgWidget', className, {
                'AgWidget--disable-padding': disablePadding,
            })}
            style={{
                '--grid-rows': gridRows,
                '--grid-columns': gridColumns,
            }}
        >
            <div className="AgWidget__header">
                {Icon ? <Icon className="AgWidget__header-icon" /> : null}
                <div className="AgWidget__header-text">{title}</div>
            </div>
            <div className="AgWidget__content">{children}</div>
        </div>
    );
}
